import type { IconSvgObject } from './types';

const ZodiacScorpioIcon: IconSvgObject = [
  ["path", { d: "M2 3.99999C3.65685 3.99998 5 5.34312 5 6.99997V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 17V6.5C5 5.11929 6.11929 4 7.5 4C8.88071 4 10 5.11929 10 6.5V16.4828", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 17V6.5C10 5.11929 11.1193 4 12.5 4C13.8807 4 15 5.11929 15 6.5V15C15 16.1046 15.8954 17 17 17L22 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19 14C19 14 22.006 16.2139 22.006 17.006C22.006 17.7981 19 20.0119 19 20.0119", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ZodiacScorpioIcon;
